import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { setDoctorOpdFee, setUserProfile } from '../Store/authSlice';
import { setEmailUpdateVerifyToken, setUpdateEmailToken } from '../Store/commonSlice';
import useApi from '../useApis';
import { setServices } from '../Store/serviceSlice';

const useProfile = () => {
  const services = useSelector((state) => state?.serviceReducer?.services);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [doctorTimes, setDoctorTime] = useState([]);
  const [otpUpdateEmail, setOtpForUpdateEmail] = useState('');
  const [otpVerified, setOtpVerified] = useState(undefined);
  const [profile, setProfile] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const api = useApi();
  //This api provides listing of Patients
  const getDoctorTime = async () => {
    setLoading(true);
    const response = await api?.getDoctorTimes();
    if (response?.data?.headers?.code === 200) {
      setDoctorTime(response?.data?.body);
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false)
  };
  const addDoctorTime = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.addDoctorTime(params);
    if (response?.data?.headers?.code === 200) {
      getDoctorTime();
      toast.success('Add Doctor time successfully');
      if (typeof onSuccess === 'function') {
        onSuccess();
      }
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const patientDuration = async (params) => {
    setLoading(true);
    const response = await api?.patientDuration(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Clinic Duration set successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const generateOtpForUpdateEmail = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.generateOtpUpdateEmail(params);
    if (response?.data?.headers?.code === 200) {
      setOtpForUpdateEmail(response?.data?.body?.otp);
      if (typeof onCancel === 'function') {
        onCancel();
      }
      setOtpForUpdateEmail(response?.data?.body?.otp);
      await dispatch(setUpdateEmailToken(response?.data?.body?.accessToken));
      toast.success('Otp sent your email');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const verifyOtpForUpdateEmail = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.verifyOtpForUpdateEmail(params);
    if (response?.data?.headers?.code === 200) {
      dispatch(setEmailUpdateVerifyToken(response?.data?.body?.accessToken));
      if (typeof onCancel === 'function') {
        onCancel();
      }
      setOtpVerified(true);
    } else {
      toast.error(response?.data?.headers?.msg);
      setOtpVerified(false);
    }
    setLoading(false);
  };
  const updateEmail = async (params = null, onSuccess) => {
    setLoading(true);
    const response = await api?.updateEmail(params);
    if (response?.data?.headers?.code === 200) {
      await getProfile();
      if (typeof onSuccess === 'function') onSuccess();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const updateSecondaryNumber = async (params = null, onSuccess) => {
    setLoading(true);
    const response = await api?.updateSecondaryNumber(params);
    if (response?.data?.headers?.code === 200) {
      getProfile();
      toast.success('Secondary number updated successfully');
      if (typeof onSuccess === 'function') onSuccess();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const updatePassword = async (params = null, onSuccess) => {
    setLoading(true);
    const response = await api?.updatePassword(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Password updated successfully');
      if (typeof onSuccess === 'function') onSuccess();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const getProfile = async (params = null, onSuccess) => {
    const response = await api?.getProfile(params);
    if (response?.data?.headers?.code === 200) {
      dispatch(setUserProfile(response?.data?.body));
      setProfile(response?.data?.body);
      if (typeof onSuccess === 'function') onSuccess();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };
  const getDoctorFee = async (params = null, onSuccess) => {
    const response = await api?.getDoctorFee(params);
    if (response?.data?.headers?.code === 200) {
      // {serviceId: null, serviceFees: 5000, serviceName: 'OPD'}
      const replaceFee = services?.filter((data) => data?.serviceId != null);
      dispatch(setDoctorOpdFee(response?.data?.body?.feeAmount));
      dispatch(
        setServices([
          { serviceId: null, serviceFees: response?.data?.body?.feeAmount, serviceName: 'OPD' },
          ...replaceFee
        ])
      );
      // setServices()
      if (typeof onSuccess === 'function') onSuccess();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };
  const updateProfileImage = async (params = null, onSuccess) => {
    setLoading(true);
    const response = await api?.updateProfileImage(params);
    if (response?.data?.headers?.code === 200) {
      setProfileImage(response?.data?.body);
      if (typeof onSuccess === 'function') onSuccess();
      await getProfile();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const deleteDoctorTime = async (params = null, onSuccess) => {
    setLoading(true);
    const response = await api?.deleteDoctorTime(params);
    if (response?.data?.headers?.code === 200) {
      getDoctorTime();
      if (typeof onSuccess === 'function') onSuccess();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const updateDoctorTime = async (params = null, onSuccess) => {
    setLoading(true);
    const response = await api?.updateDoctorTime(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Time updated successfully');
      getDoctorTime();
      if (typeof onSuccess === 'function') onSuccess();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const updateSmsControl = async (params = null, onSuccess) => {
    setLoading(true);
    const response = await api?.updateSmsControl(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('SMS update');
      getDoctorTime();
      if (typeof onSuccess === 'function') onSuccess();
      setLoading(false);
      return true;
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const updateAppointments = async (params, onSuccess) => {
    setLoading(true);
    const response = await api?.updateAppointments(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('SMS update');
      if (typeof onSuccess === 'function') onSuccess();
      getDoctorTime();

      setLoading(false);
      return true;
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  return {
    loading,
    addDoctorTime,
    getDoctorTime,
    appointments,
    setAppointments,
    patientDuration,
    doctorTimes,
    otpUpdateEmail,
    generateOtpForUpdateEmail,
    updateEmail,
    verifyOtpForUpdateEmail,
    otpVerified,
    updateSecondaryNumber,
    updatePassword,
    getProfile,
    profile,
    profileImage,
    updateProfileImage,
    getDoctorFee,
    deleteDoctorTime,
    updateDoctorTime,
    updateSmsControl,
    updateAppointments
  };
};

export default useProfile;
